import { IntegrationPartner } from "refsix-js-models";
import React, { FC } from "react";

import assignrLogo from "../../assets/images/icon/assignr-square-icon.png";
import refinsightLogo from "../../assets/images/icon/refinsight-square-icon.png";
import refassistLogo from "../../assets/images/icon/refassist-logo-small.png";
import soccerRefManagerLogo from "../../assets/images/icon/soccerrefmanager-square-icon.png";
import { IonImg } from "@ionic/react";

interface IntegrationIconProps {
    partner: IntegrationPartner | undefined;
}

const logoMapping = (p: IntegrationPartner | undefined) => {
    switch (p) {
        case IntegrationPartner.assignr:
            return assignrLogo;
        case IntegrationPartner.refinsight:
            return refinsightLogo;
        case IntegrationPartner.refassist:
            return refassistLogo;
        case IntegrationPartner.soccerRefManager:
            return soccerRefManagerLogo;
        default:
            return "";
    }
};
export const IntegrationIcon: FC<IntegrationIconProps> = ({ partner }) => {
    const logo = logoMapping(partner);
    if (logo) {
        const isSoccerRefManager =
            partner === IntegrationPartner.soccerRefManager;
        return (
            <div className="integration-icon">
                <IonImg
                    src={logo}
                    style={
                        isSoccerRefManager
                            ? { filter: "brightness(0) invert(1)" }
                            : undefined
                    }
                />
            </div>
        );
    } else {
        return <></>;
    }
};
